import Flickity from "flickity";
// import "lazysizes";
// import "lazysizes/plugins/respimg/ls.respimg";
// import "lazysizes/plugins/rias/ls.rias";
// import "lazysizes/plugins/bgset/ls.bgset";
// import "lazysizes/plugins/object-fit/ls.object-fit";
// import "lazysizes/plugins/parent-fit/ls.parent-fit";

window.Flickity = window.flickity = Flickity;